import { PeopleSyncRegular, ShieldArrowRightRegular } from "@fluentui/react-icons";
import { ActionButton } from "components/styled";
import { useAtomValue } from "jotai";
import { IExcelReportResponse } from "library/types";
import { downloadFile } from "library/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { generateConsentData } from "state/queries/useGenerateConsentData";
import { selectedCompanyState } from "store/UIHrPage";

export function ExportConsentData() {
  const { t } = useTranslation();
  const selectedCompany = useAtomValue(selectedCompanyState);

  const [consentDataLoading, setConsentDataLoading] = useState(false);
  const [consentData, setConsentData] =
    useState<IExcelReportResponse | null>(null);

  useEffect(() => {
    setConsentData(null);
  }, [selectedCompany]);

  return (
    <ActionButton
      noBorder
      appearance="subtle"
      disabled={consentDataLoading}
      icon={<ShieldArrowRightRegular />}
      onClick={async () => {
        if (consentData) {
          downloadFile(consentData, consentData.name);
          return;
        }
        setConsentDataLoading(true);
        const consentDataResponse = await generateConsentData({
          countryCode: Number(selectedCompany?.countryCode) || 0,
          clientInternalNumberGos:
            Number(selectedCompany?.clientInternalNumberGos) || 0,
        });
        setConsentDataLoading(false);
        setConsentData(consentDataResponse);
        downloadFile(consentDataResponse, consentDataResponse.name);
      }}
    >
      {t("hbh.exportConsentData.label")}
    </ActionButton>
  );
}
